import type { MouseEvent } from 'react';

const MIDDLE_MOUSE_BUTTON = 1;

export function isMiddleClick(event: MouseEvent): boolean {
    return event.button === MIDDLE_MOUSE_BUTTON;
}

export function isDirectMiddleClick(event: MouseEvent): boolean {
    if (!isMiddleClick(event)) return false;
    const nestedControl = (event.target as Element).closest('a, button');
    return (
        nestedControl === null || !event.currentTarget.contains(nestedControl)
    );
}

export function isOpenInNewTabClick(event?: MouseEvent): boolean {
    if (!event) return false;
    return isMiddleClick(event) || event.metaKey || event.ctrlKey;
}

export function preventMiddleClickAutoscroll(event: MouseEvent): void {
    if (isMiddleClick(event)) event.preventDefault();
}
